'use strict';

var polycardStore = require('./polycardStore-aece707b.cjs');
var React = require('react');
var jsxRuntime = require('react/jsx-runtime');
var button = require('@andes/button');
var phrase = require('@polycard/phrase');
var classnames = require('classnames');
var ProgressIndicatorLinear = require('@andes/progress-indicator-linear');
var Image = require('frontend-image');
var CheckboxAndes = require('@andes/checkbox');
var CardUI = require('@andes/card');
var Tag = require('@andes/tag');
var inputStepper = require('@andes/input-stepper');
var priceAmount = require('@polycard/price-amount');
var moneyAmount = require('@andes/money-amount');
var dropdown = require('@andes/dropdown');
var list = require('@andes/list');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classnames__default = /*#__PURE__*/_interopDefaultLegacy(classnames);
var ProgressIndicatorLinear__default = /*#__PURE__*/_interopDefaultLegacy(ProgressIndicatorLinear);
var Image__default = /*#__PURE__*/_interopDefaultLegacy(Image);
var CheckboxAndes__default = /*#__PURE__*/_interopDefaultLegacy(CheckboxAndes);
var CardUI__default = /*#__PURE__*/_interopDefaultLegacy(CardUI);
var Tag__default = /*#__PURE__*/_interopDefaultLegacy(Tag);
const cardContext = /*#__PURE__*/React.createContext(undefined);
const CardContext = _ref => {
  let {
    contextValue,
    children
  } = _ref;
  const {
    url,
    onClick,
    metadata: {
      item_ids_for_removal,
      id
    }
  } = contextValue;
  const handleClick = event => {
    if (onClick) {
      onClick(event, {
        url,
        id,
        item_ids_for_removal
      });
    }
  };
  const value = polycardStore._extends({}, contextValue, {
    onClick: handleClick
  });
  return jsxRuntime.jsx(cardContext.Provider, {
    value: value,
    children: children
  });
};
function useCardContext() {
  const context = React.useContext(cardContext);
  if (context === undefined) {
    throw new Error(polycardStore.MsgCardContextError);
  }
  return context;
}
const useEvaluationsCard = _ref => {
  let {
    type,
    isMobile,
    isTablet,
    deviceType,
    image_ratio,
    pictures,
    image_square,
    vertical_id,
    card_size
  } = _ref;
  const evaluations = React.useMemo(() => {
    const isGrid = Boolean(type == null ? void 0 : type.includes('grid'));
    const isSingle = Boolean(type == null ? void 0 : type.includes('single'));
    const isList = Boolean(type == null ? void 0 : type.includes('list'));
    const isTwoCols = isList && deviceType === 'desktop';
    const isImageReSize = image_ratio && isMobile && isList && card_size === 'large';
    const isListHeight = Boolean(isImageReSize && Number(image_ratio) < 0.9);
    const isGridHeight = isMobile && isGrid && vertical_id !== 'RES' && card_size === 'large';
    const isCarousel = !!(pictures != null && pictures.pictures) && (pictures == null ? void 0 : pictures.pictures.length) > 1;
    const squareMobile = image_square && isMobile && card_size === 'large' ? image_square : undefined;
    const Imagewrapper = isListHeight && !isCarousel ? 'figure' : React.Fragment;
    const shouldDisplayLabelPill = isGrid && !isMobile && card_size === 'large';
    const isDesktop = !isMobile && !isTablet;
    return {
      isGrid,
      isSingle,
      isList,
      isTwoCols,
      isListHeight,
      isGridHeight,
      isCarousel,
      squareMobile,
      Imagewrapper,
      shouldDisplayLabelPill,
      isDesktop
    };
  }, [type, isMobile, isTablet, deviceType, image_ratio, pictures, image_square, vertical_id, card_size]);
  return evaluations;
};
const cardNamespace = 'poly';
const getListMap = item => {
  if (!item.column) return [item, null, null];
  if (item.column === 1) return [null, item, null];
  if (item.column === 2) return [null, null, item];
  return [null, null, null];
};
const getPrev = prev => prev != null ? prev : [];
const getCurr = curr => curr ? [curr] : [];
const getReduceMap = (prev, curr) => [[...getPrev(prev[0]), ...getCurr(curr[0])], [...getPrev(prev[1]), ...getCurr(curr[1])], [...getPrev(prev[2]), ...getCurr(curr[2])]];
const getColProps = (isTwoCols, components) => {
  const [col, col1, col2] = isTwoCols ? components.map(getListMap).reduce(getReduceMap, [[], [], []]) : [components, [], []];
  return [{
    components: col
  }, {
    components: col1
  }, {
    components: col2
  }];
};
const getKey = (base, itemId, index) => {
  if (typeof base !== 'string') {
    var _base$id;
    if (base.type === 'pill') {
      var _base$pill$text$toLow, _base$pill;
      return (_base$pill$text$toLow = (_base$pill = base.pill) == null || (_base$pill = _base$pill.text) == null || (_base$pill = _base$pill.toLowerCase()) == null || (_base$pill = _base$pill.split(' ')) == null ? void 0 : _base$pill.join('_')) != null ? _base$pill$text$toLow : 'pill_empty';
    }
    return `${(_base$id = base.id) != null ? _base$id : base.type}-${itemId}${index ? `-${index}` : ''}`;
  }
  return `${base}-${itemId}${index ? `-${index}` : ''}`;
};
const getUrl = (metadata, url_params, url_prefix, url_params_default, url_fragments_default, url_fragments_variations, url_variations) => {
  var _ref, _ref2, _ref3, _ref4;
  const {
    url: url_meta,
    url_fragments: url_fragments_metadata,
    url_params: url_params_metadata
  } = metadata;
  const variationParams = url_params && `?${url_params}`;
  const url_base = url_variations != null ? url_variations : url_meta;
  if (!url_base) {
    return '';
  }
  const urlHasPrefix = url_base.startsWith('https://') || url_base.startsWith('meli://');
  const prefix = !urlHasPrefix && !!url_prefix ? url_prefix : '';
  const params = (_ref = (_ref2 = variationParams != null ? variationParams : url_params_metadata) != null ? _ref2 : url_params_default) != null ? _ref : '';
  const fragments = (_ref3 = (_ref4 = url_fragments_variations != null ? url_fragments_variations : url_fragments_metadata) != null ? _ref4 : url_fragments_default) != null ? _ref3 : '';
  return `${prefix}${url_base}${params}${fragments}`;
};
const regex = /{(.*?)}/gm;
const interpolationMatcher = text => text == null ? void 0 : text.match(regex);
const namespace$l = `${cardNamespace}-action`;
const Action = _ref => {
  let {
    text,
    callback,
    type = 'link',
    hierarchy,
    values
  } = _ref;
  const {
    metadata
  } = useCardContext();
  const {
    card_size
  } = polycardStore.usePolycardContext();
  const id = metadata.item_ids_for_removal || metadata.id;
  const matchValue = interpolationMatcher(text);
  const handleSubmit = event => {
    if (callback) {
      callback(event, id);
    }
  };
  const formatText = () => {
    if (!matchValue) return text;
    return jsxRuntime.jsx(phrase.Phrase, {
      text: text,
      isAsText: false,
      values: values
    });
  };
  return jsxRuntime.jsxs("div", {
    className: namespace$l,
    children: [jsxRuntime.jsx("input", {
      type: "hidden",
      name: "id",
      value: id
    }), type === 'link' ? jsxRuntime.jsx("button", {
      className: `${namespace$l}__button`,
      type: "button",
      onClick: handleSubmit,
      children: formatText()
    }) : jsxRuntime.jsx(button.Button, {
      type: "submit",
      hierarchy: hierarchy,
      onClick: handleSubmit,
      size: card_size,
      children: jsxRuntime.jsx(button.ButtonText, {
        children: formatText()
      })
    })]
  });
};
const namespace$k = `${cardNamespace}-component__link`;
const Link = _ref => {
  let {
    rel,
    url,
    text,
    children,
    className,
    classModified,
    onClick,
    target,
    type = 'link',
    hierarchy,
    values
  } = _ref;
  const {
    card_size
  } = polycardStore.usePolycardContext();
  const matchValue = interpolationMatcher(text);
  if ((!text || !children) && !url) return null;
  const linkClasess = classnames__default["default"](className, namespace$k, {
    [`${namespace$k}--${classModified}`]: !!classModified
  });
  const formatText = () => {
    if (!text) return children;
    if (!matchValue) return text;
    return jsxRuntime.jsx(phrase.Phrase, {
      text: text,
      isAsText: false,
      values: values
    });
  };
  return type === 'link' ? jsxRuntime.jsx("a", {
    href: url,
    className: linkClasess,
    onClick: onClick,
    rel: rel,
    target: target,
    children: formatText()
  }) : jsxRuntime.jsx(button.Button, {
    href: url,
    hierarchy: hierarchy,
    size: card_size,
    children: jsxRuntime.jsx(button.ButtonText, {
      children: formatText()
    })
  });
};
const namespace$j = `${cardNamespace}-action-links`;
const ActionLinks = _ref => {
  let {
    action_links,
    className
  } = _ref;
  const {
    actionCallbacks
  } = polycardStore.usePolycardContext();
  const hasButtons = action_links == null ? void 0 : action_links.some(_ref2 => {
    let {
      type
    } = _ref2;
    return type === 'button';
  });
  const wrapperClasses = classnames__default["default"](namespace$j, className, {
    [`${className}--buttons`]: hasButtons
  });
  return jsxRuntime.jsx("div", {
    className: wrapperClasses,
    children: action_links == null ? void 0 : action_links.map(action => {
      const actionCallback = actionCallbacks ? actionCallbacks.find(_ref3 => {
        let {
          id
        } = _ref3;
        return id === action.id;
      }) : null;
      const actionComponent = actionCallback && actionCallback.callback ? jsxRuntime.jsx(Action, polycardStore._extends({}, action, {
        callback: actionCallback.callback
      })) : jsxRuntime.jsx(Link, polycardStore._extends({}, action, {
        classModified: "action-link"
      }));
      const containerClasses = classnames__default["default"](`${namespace$j}__action`, {
        [`${namespace$j}__action--${action.type}`]: !!action.type
      });
      return jsxRuntime.jsx("div", {
        className: containerClasses,
        children: actionComponent
      }, action.id);
    })
  });
};
const BaseText = _ref => {
  let {
    alt_text,
    className,
    styles,
    target,
    text,
    url,
    values
  } = _ref;
  const {
    thousandSeparator,
    decimalSeparator
  } = polycardStore.usePolycardContext();
  return jsxRuntime.jsx(phrase.Phrase, {
    alt_text: alt_text,
    className: className,
    styles: styles,
    target: target,
    text: text,
    url: url,
    values: values,
    thousandSeparator: thousandSeparator,
    decimalSeparator: decimalSeparator
  });
};
const BlockText = props => jsxRuntime.jsx(BaseText, polycardStore._extends({}, props));
const namespace$i = `${cardNamespace}-bookmark`;
const componentNameSpace$2 = `${cardNamespace}-component__bookmark`;
const Bookmark = () => {
  const {
    metadata,
    bookmark: bookmarkComponent
  } = useCardContext();
  if (!bookmarkComponent) {
    return null;
  }
  const {
    bookmarkAction,
    bookmarked,
    alt_text
  } = bookmarkComponent;
  const handleSubmit = event => {
    event.preventDefault();
    if (bookmarkAction) {
      bookmarkAction(event, metadata.id);
    }
  };
  const bookmarkClassName = classnames__default["default"](componentNameSpace$2);
  const btnClassName = classnames__default["default"](`${namespace$i}__btn`, {
    [`${namespace$i}__btn--active`]: bookmarked
  });
  const iconClassNameFull = classnames__default["default"](`${namespace$i}__icon-full`);
  const IconClassNameEmpty = classnames__default["default"](`${namespace$i}__icon-empty`);
  const values = [{
    type: 'icon',
    key: 'icon_bookmark',
    icon: {
      key: 'bookmark'
    }
  }];
  return jsxRuntime.jsx("div", {
    className: bookmarkClassName,
    children: jsxRuntime.jsxs("button", {
      type: "button",
      className: btnClassName,
      role: "switch",
      "aria-checked": bookmarked,
      "aria-label": alt_text || 'favorito',
      onClick: handleSubmit,
      children: [jsxRuntime.jsx(phrase.Phrase, {
        text: "{icon_bookmark}",
        iconClassName: iconClassNameFull,
        isAsText: false,
        values: values
      }), jsxRuntime.jsx(phrase.Phrase, {
        text: "{icon_bookmark}",
        iconClassName: IconClassNameEmpty,
        isAsText: false,
        values: values
      })]
    })
  });
};
const ImageOverlay = _ref => {
  let {
    overlay
  } = _ref;
  const {
    isMobile,
    picture_overlay_default
  } = polycardStore.usePolycardContext();
  const {
    metadata: {
      vertical_id
    }
  } = useCardContext();
  const pictureOverlay = overlay != null ? overlay : picture_overlay_default;
  // Devuelve null si no quieres renderizar nada
  const shouldRenderOverlay = pictureOverlay !== undefined ? pictureOverlay : isMobile && vertical_id === 'CORE';
  return shouldRenderOverlay ? jsxRuntime.jsx("span", {
    className: "poly-component__image-overlay"
  }) : null;
};
const Loading = () => {
  const [progress, setProgress] = React.useState(0);
  const {
    metadata
  } = useCardContext();
  const {
    isLoading
  } = metadata;
  React.useEffect(() => {
    if (isLoading && progress < 100) {
      const interval = setInterval(() => {
        setProgress(progress + 1);
      }, 20);
      return () => {
        clearInterval(interval); // Limpia el intervalo al desmontar el componente
      };
    }
    setProgress(0);
    return () => {}; // Return an empty function to satisfy the expected return value
  }, [isLoading, progress]);
  return isLoading && jsxRuntime.jsx("div", {
    className: "poly-component__loading",
    children: jsxRuntime.jsx(ProgressIndicatorLinear__default["default"], {
      id: "poly-progress-indicator-linear",
      srAnnouncement: "Cargando...",
      srLabel: `Progreso de subida ${{
        progress
      }}`,
      value: progress
    })
  });
};
const lazyOn = 'on';
const lazyOff = 'off';
const getURLs = (picture_template, vars) => picture_template.replace(/{(\w+|\d+x)}/g, (_, key) => vars[key] || '');
const componentNameSpace$1 = `${cardNamespace}-component__picture`;
const Picture = _ref => {
  let {
    square,
    size,
    isCarousel,
    lazyload,
    preload,
    alt,
    id,
    className,
    src,
    sanitized_title,
    ariaHidden = false
  } = _ref;
  const {
    picture_template,
    picture_size_default,
    picture_square_default,
    lowEnd = false,
    isMobile
  } = polycardStore.usePolycardContext();
  const {
    metadata: {
      vertical_id
    }
  } = useCardContext();
  const squareValue = square != null ? square : picture_square_default;
  const sizeValue = size != null ? size : picture_size_default;
  const srcURL_2X = !src && getURLs(picture_template, {
    square: squareValue,
    '2x': '_2X',
    id,
    size: sizeValue,
    sanitized_title
  });
  return jsxRuntime.jsx(Image__default["default"], {
    className: classnames__default["default"](className, componentNameSpace$1, {
      [`${componentNameSpace$1}--contain`]: squareValue === 'Q' && vertical_id === 'MOT' || vertical_id !== 'RES' && isMobile
    }),
    carousel: isCarousel,
    lazyload: lazyload ? lazyOn : lazyOff,
    lowEnd: lowEnd,
    preload: preload,
    src: src || srcURL_2X,
    alt: alt || '',
    title: alt || null,
    width: 150,
    height: 150,
    "aria-hidden": ariaHidden
  });
};
const namespace$h = `${cardNamespace}-component__carousel`;
const Carousel = _ref => {
  let {
    url,
    size,
    title,
    alt_text,
    pictures,
    variationId,
    onClick,
    square,
    sanitized_title
  } = _ref;
  const [currentSlide, setCurrentSlide] = React.useState(0);
  const {
    onAfterImageChange
  } = useCardContext();
  const {
    isMobile,
    targetLink,
    isTablet
  } = polycardStore.usePolycardContext();
  const [carouselModule, setCarouselModule] = React.useState(null);
  // Importar la librería de forma dinámica
  React.useEffect(() => {
    Promise.resolve().then(function () {
      return /*#__PURE__*/_interopNamespace(require('@andes/carousel-snapped'));
    }).then(modulo => {
      setCarouselModule(modulo);
    }).catch(error => {
      // eslint-disable-next-line no-console
      console.error('Error al importar la librería:', error);
    });
  }, []);
  const handleAfterImageChange = slideIndex => {
    if (onAfterImageChange) {
      onAfterImageChange(slideIndex);
    }
  };
  return carouselModule && jsxRuntime.jsx(carouselModule.default, {
    className: classnames__default["default"](namespace$h, {
      [`${namespace$h}--bg-white `]: currentSlide > 0
    }),
    pagination: pictures.length > 1 && pictures.length < 6 && isMobile,
    type: "full",
    arrows: {
      visibility: isMobile || isTablet ? 'always' : 'hover' // default: 'always'
    },
    lazyload: true,
    srLabel: title,
    beforeChange: (_currentSlide, _newSlide) => setCurrentSlide(_newSlide),
    afterChange: handleAfterImageChange,
    children: pictures.map((_ref2, index) => {
      let {
        id,
        alt,
        preload,
        lazyload
      } = _ref2;
      const isPreload = preload != null ? preload : false;
      const islazyload = lazyload != null ? lazyload : false;
      const altText = alt != null ? alt : `${title} ${alt_text != null ? alt_text : ''} - ${index + 1}/${pictures.length}`;
      return jsxRuntime.jsx(carouselModule.CarouselSnappedSlide, {
        children: jsxRuntime.jsx(Link, {
          url: url,
          onClick: onClick,
          classModified: "carousel",
          target: targetLink,
          children: jsxRuntime.jsx(Picture, {
            id: id,
            alt: altText,
            preload: isPreload,
            lazyload: islazyload,
            square: square,
            size: size,
            sanitized_title: sanitized_title,
            isCarousel: true
          })
        })
      }, id);
    })
  }, `${variationId}-${pictures[0].id}-${pictures.length}`);
};
const namespace$g = `${cardNamespace}-component`;
const ImagesContainer = _ref => {
  let {
    alt_text,
    Imagewrapper,
    isCarousel,
    isListHeight,
    overlay,
    pictures,
    sanitized_title,
    size,
    square
  } = _ref;
  const {
    countPreloadImages,
    isMobile,
    isTablet
  } = polycardStore.usePolycardContext();
  const {
    cardNumber,
    useLazyImage,
    isHover = false,
    onClick,
    url,
    title,
    metadata
  } = useCardContext();
  const [isCarouselAlreadyRendered, setIsCarouselAlreadyRendered] = React.useState(false);
  const {
    vertical_id
  } = metadata;
  const {
    id,
    alt,
    preload,
    lazyload
  } = pictures[0];
  // calculamos si la imagen no debe ser lazy
  const isNotLazy = !!countPreloadImages && !!cardNumber && cardNumber <= countPreloadImages;
  const isPreload = preload != null ? preload : false;
  const islazyload = lazyload != null ? lazyload : !isPreload;
  React.useEffect(() => {
    const shouldRenderCarousel = () => {
      if (isCarouselAlreadyRendered) return false;
      if (!isMobile && isCarousel && isHover) return true;
      if (isMobile && vertical_id === 'RES' || isTablet) return true;
      return false;
    };
    const shouldRender = shouldRenderCarousel();
    if (shouldRender) {
      setIsCarouselAlreadyRendered(true);
      if (window.imageLazyLoading) {
        window.imageLazyLoading('lazy-loadable', {
          loadMode: 'lazyload'
        });
      }
    }
  }, [isCarouselAlreadyRendered, isCarousel, isHover, isMobile, isTablet, vertical_id]);
  const memoCarouselComponent = React.useMemo(() => {
    if (isCarouselAlreadyRendered) {
      return jsxRuntime.jsx(Carousel, {
        url: url,
        size: size,
        pictures: pictures,
        variationId: pictures[0].id,
        square: square,
        onClick: onClick,
        title: title,
        alt_text: alt_text,
        sanitized_title: sanitized_title
      });
    }
    return jsxRuntime.jsx("span", {});
  }, [isCarouselAlreadyRendered, onClick, pictures, size, title, url, square, alt_text]);
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [jsxRuntime.jsx(Loading, {}), isCarouselAlreadyRendered && isCarousel && memoCarouselComponent, !isCarouselAlreadyRendered && jsxRuntime.jsx(ImageOverlay, {
      overlay: overlay
    }), jsxRuntime.jsx(Imagewrapper, polycardStore._extends({}, isMobile && {
      className: classnames__default["default"](`${namespace$g}__image-wrapper`, {
        [`${namespace$g}__image-wrapper--image-height`]: isListHeight
      })
    }, {
      children: jsxRuntime.jsx(Picture, {
        id: id,
        alt: alt || title,
        size: size,
        square: square,
        preload: isPreload || isNotLazy,
        lazyload: useLazyImage != null ? useLazyImage : islazyload && !isNotLazy,
        isCarousel: isCarousel,
        sanitized_title: sanitized_title,
        ariaHidden: true
      })
    }))]
  });
};
const namespace$f = `${cardNamespace}-card__checkbox`;
const Checkbox = _ref => {
  let {
    className
  } = _ref;
  const {
    checkbox,
    isMobile
  } = polycardStore.usePolycardContext();
  const {
    metadata,
    checkbox: checkboxComponent
  } = useCardContext();
  if (!checkbox || isMobile || !checkboxComponent) {
    return null;
  }
  const {
    handleCheckbox,
    checked
  } = checkboxComponent;
  const handleCheckboxChange = event => {
    if (handleCheckbox) {
      handleCheckbox(event, metadata.id);
    }
  };
  return jsxRuntime.jsx("div", {
    className: classnames__default["default"](className, `${namespace$f}`),
    children: jsxRuntime.jsx(CheckboxAndes__default["default"], {
      checked: checked,
      onChange: handleCheckboxChange
    })
  });
};
const AndesCard = _ref => {
  let {
    children,
    className,
    styles,
    paddingSize,
    forwardedRef,
    onMouseEnter,
    onMouseLeave
  } = _ref;
  const {
    isHover
  } = useCardContext();
  const shadowType = isHover ? 'elevated' : 'flat';
  return jsxRuntime.jsx(CardUI__default["default"], {
    paddingSize: paddingSize != null ? paddingSize : 0,
    className: className,
    shadow: shadowType,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    animated: true,
    style: styles,
    ref: forwardedRef,
    children: children
  });
};
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
const _excluded$3 = ["tagName", "forwardedRef", "children", "className", "style"];
const DynamicElement = _ref => {
  let {
      tagName,
      forwardedRef,
      children,
      className,
      style
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  return /*#__PURE__*/React__default["default"].createElement(tagName, polycardStore._extends({}, props, {
    ref: forwardedRef,
    className,
    style
  }), children);
};
const Layout = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    className,
    styles,
    as = 'div',
    id,
    onMouseEnter,
    onMouseLeave
  } = _ref;
  const {
    type
  } = polycardStore.usePolycardContext();
  const commonProps = {
    forwardedRef: ref,
    className,
    styles,
    onMouseEnter,
    onMouseLeave,
    id
  };
  switch (type) {
    case 'list':
    case 'list-multicolumn':
    case 'single':
      return jsxRuntime.jsxs(DynamicElement, polycardStore._extends({
        tagName: as
      }, commonProps, {
        children: [type.startsWith('list') && jsxRuntime.jsx(Checkbox, {}), children]
      }));
    case 'list-card':
    case 'grid-card':
      return jsxRuntime.jsx(AndesCard, polycardStore._extends({
        paddingSize: type === 'grid-card' ? 0 : undefined
      }, commonProps, {
        children: children
      }));
    default:
      return jsxRuntime.jsx(DynamicElement, polycardStore._extends({
        tagName: as
      }, commonProps, {
        children: children
      }));
  }
});
const namespace$e = `${cardNamespace}-suggestions`;
const componentNameSpace = `${cardNamespace}-component__suggestions`;
const Suggestions = () => {
  const [isClosing, setIsClosing] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(false);
  const {
    type
  } = polycardStore.usePolycardContext();
  const {
    suggestions,
    needSuggestions,
    setNeedSuggestions,
    addToCartActions
  } = useCardContext();
  React.useEffect(() => {
    if (needSuggestions && suggestions) {
      setIsOpen(true);
      setIsClosing(false);
    } else {
      setIsOpen(false);
      setIsClosing(true);
    }
  }, [needSuggestions, suggestions]);
  const handleClose = () => {
    if (setNeedSuggestions) {
      setIsOpen(false);
      setNeedSuggestions(false);
      setIsClosing(true);
    }
  };
  const handleActionClick = tag => {
    if (addToCartActions && addToCartActions['handleSuggestionsButtonTrack']) {
      addToCartActions['handleSuggestionsButtonTrack'](tag);
    }
  };
  const mainClassName = classnames__default["default"](componentNameSpace, `${componentNameSpace}--${type === 'list-multicolumn' ? 'list' : type}`, {
    [`${componentNameSpace}--close`]: isClosing,
    [`${componentNameSpace}--open`]: isOpen
  });
  return suggestions ? jsxRuntime.jsxs("div", {
    className: `${mainClassName}`,
    children: [jsxRuntime.jsxs("div", {
      className: `${namespace$e}__header`,
      children: [jsxRuntime.jsxs("div", {
        className: `${namespace$e}__header-title`,
        children: [jsxRuntime.jsx(phrase.Phrase, {
          text: "{spotlight_compatible_green_icon}",
          isAsText: false
        }), jsxRuntime.jsx("h3", {
          className: `${namespace$e}__title`,
          children: suggestions == null ? void 0 : suggestions.title.text
        })]
      }), jsxRuntime.jsx("button", {
        className: `${namespace$e}__close`,
        onClick: handleClose,
        type: "button",
        tabIndex: 0,
        children: jsxRuntime.jsx(phrase.Phrase, {
          text: "{icon_close}",
          isAsText: false
        })
      })]
    }), jsxRuntime.jsxs("div", {
      className: `${namespace$e}__content`,
      children: [jsxRuntime.jsx("h3", {
        className: `${namespace$e}__subtitle`,
        children: suggestions == null ? void 0 : suggestions.subtitle.text
      }), jsxRuntime.jsx("ul", {
        className: `${namespace$e}__list`,
        children: suggestions == null ? void 0 : suggestions.tags.map(tag => jsxRuntime.jsx("li", {
          className: `${namespace$e}__item`,
          children: jsxRuntime.jsx("a", {
            className: `${namespace$e}__link`,
            onClick: () => handleActionClick(tag),
            href: tag.url,
            children: jsxRuntime.jsx(Tag__default["default"], {
              label: tag.name,
              className: `${namespace$e}__tag`
            })
          })
        }, `${tag.category_id}`))
      })]
    })]
  }) : null;
};
const namespace$d = `${cardNamespace}-add-to-cart`;
const AddToCartButton = _ref => {
  let {
    text,
    cart_status,
    cart_config
  } = _ref;
  const [isInCart, setIsInCart] = React.useState(cart_status && (cart_status == null ? void 0 : cart_status.quantity) !== 0);
  const [hasCalledFirst, setHasCalledFirst] = React.useState(false);
  const {
    addToCartActions,
    setNeedSuggestions
  } = useCardContext();
  const {
    metadata,
    url
  } = useCardContext();
  const {
    id
  } = metadata;
  const handleActionClick = function (action, e, isFirstCall) {
    if (isFirstCall === void 0) {
      isFirstCall = false;
    }
    if (addToCartActions) {
      var _addToCartActions$act;
      (_addToCartActions$act = addToCartActions[action]) == null || _addToCartActions$act.call(addToCartActions, e, url, id);
    }
    if (isFirstCall && setNeedSuggestions) {
      setNeedSuggestions(true);
      setHasCalledFirst(true);
    }
  };
  React.useEffect(() => {
    if (cart_status) {
      setIsInCart(cart_status.quantity !== 0);
      if (cart_status.quantity === 0 && setNeedSuggestions) {
        setNeedSuggestions(false);
        setHasCalledFirst(false);
      }
    }
  }, [cart_status, cart_status == null ? void 0 : cart_status.quantity]);
  return isInCart ? jsxRuntime.jsx(inputStepper.InputStepper, {
    className: `${namespace$d}__button--steper`,
    srLabel: `${cart_status == null ? void 0 : cart_status.quantity} ${cart_status == null ? void 0 : cart_status.quantity}`,
    complementaryText: cart_status == null ? void 0 : cart_status.text,
    decrementButtonProps: {
      onClick: e => handleActionClick('handleAddToCartDelete', e, !hasCalledFirst)
    },
    id: id,
    incrementButtonProps: {
      onClick: e => handleActionClick('handleAddToCartPut', e, !hasCalledFirst)
    },
    maxValue: cart_config == null ? void 0 : cart_config.max_add_quantity,
    size: "small",
    value: cart_status == null ? void 0 : cart_status.quantity,
    formatValue: value => (cart_status == null ? void 0 : cart_status.format_value) || value
  }) : jsxRuntime.jsx(button.Button, {
    className: `${namespace$d}__button--no-items`,
    fullWidth: true,
    hierarchy: "quiet",
    size: "medium",
    onClick: e => handleActionClick('handleAddToCartPut', e, !hasCalledFirst),
    children: jsxRuntime.jsx(button.ButtonText, {
      children: text
    })
  });
};
const namespace$c = `${cardNamespace}-add-to-cart`;
const MinQuantityLabel = props => props && jsxRuntime.jsx(phrase.Phrase, polycardStore._extends({
  className: `${namespace$c}__minimum-label`
}, props));
const namespace$b = `${cardNamespace}-add-to-cart`;
const OtherOptionsButton = _ref => {
  let {
    text,
    url,
    target
  } = _ref;
  const {
    addToCartActions
  } = useCardContext();
  const handleActionClick = () => {
    if (addToCartActions && addToCartActions['handleAddToCartButtonTrack']) {
      addToCartActions['handleAddToCartButtonTrack']();
    }
  };
  return jsxRuntime.jsx(button.Button, {
    className: `${namespace$b}__button--other-options`,
    fullWidth: true,
    hierarchy: "quiet",
    href: url,
    target: target,
    size: "medium",
    onClick: () => handleActionClick(),
    children: jsxRuntime.jsx(button.ButtonText, {
      children: text
    })
  });
};
const namespace$a = `${cardNamespace}-add-to-cart`;
const ShippingLabel = _ref => {
  let {
    text,
    styles,
    values
  } = _ref;
  const {
    thousandSeparator,
    decimalSeparator
  } = polycardStore.usePolycardContext();
  if (!thousandSeparator || !decimalSeparator) {
    console.error(polycardStore.MsgThousandDecimalError);
    return null;
  }
  return jsxRuntime.jsx(phrase.Phrase, {
    className: `${namespace$a}__shipping-label`,
    text: text,
    styles: styles,
    values: values,
    thousandSeparator: thousandSeparator,
    decimalSeparator: decimalSeparator
  });
};
const _excluded$2 = ["text", "url", "target", "className"];
const AddToCart = _ref => {
  let {
      text,
      url,
      target,
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  const {
    cart_config,
    cart_shipping
  } = props;
  const {
    type
  } = polycardStore.usePolycardContext();
  return jsxRuntime.jsxs("div", {
    className: className,
    children: [cart_shipping && jsxRuntime.jsx(ShippingLabel, polycardStore._extends({}, cart_shipping)), ((type == null ? void 0 : type.includes('grid')) || (type == null ? void 0 : type.includes('single'))) && jsxRuntime.jsx(Suggestions, {}), url ? jsxRuntime.jsx(OtherOptionsButton, {
      text: text,
      url: url,
      target: target
    }) : jsxRuntime.jsx(AddToCartButton, polycardStore._extends({
      text: text
    }, props)), cart_config && cart_config.min_add_text && jsxRuntime.jsx(MinQuantityLabel, polycardStore._extends({}, cart_config.min_add_text))]
  });
};
const namespace$9 = `${cardNamespace}-attributes-list`;
const AttributesList = _ref => {
  let {
    texts,
    separator,
    className
  } = _ref;
  return jsxRuntime.jsx("div", {
    className: className,
    children: jsxRuntime.jsx("ul", {
      className: namespace$9,
      style: {
        '--separator-content': `"${separator}"`,
        gap: separator === ',' ? '0px' : '4px'
      },
      children: texts == null ? void 0 : texts.map(text => jsxRuntime.jsx("li", {
        className: classnames__default["default"](`${namespace$9}__item`, [`${namespace$9}__separator`, !!separator]),
        children: text
      }, text == null ? void 0 : text.toLowerCase().replace(' ', '-')))
    })
  });
};
const className = 'poly-buy-box__alternative-option';
const AlternativeOption = _ref => {
  let {
    url,
    target,
    components
  } = _ref;
  return jsxRuntime.jsx(Link, {
    url: url,
    target: target,
    className: className,
    children: jsxRuntime.jsx(ListComponents, {
      components: components
    })
  });
};
const namespace$8 = `${cardNamespace}-buy-box`;
const BuyBox = _ref => {
  let {
    alternative_options,
    className,
    text
  } = _ref;
  return jsxRuntime.jsxs("div", {
    className: className,
    children: [jsxRuntime.jsx("span", {
      className: `${namespace$8}__headline`,
      children: text
    }), alternative_options == null ? void 0 : alternative_options.map(alternativeOption => (/*#__PURE__*/React.createElement(AlternativeOption, polycardStore._extends({}, alternativeOption, {
      key: alternativeOption.url
    }))))]
  });
};
const InstallmentsPrice = _ref => {
  let {
    no_interest,
    text,
    className,
    styles,
    values
  } = _ref;
  const {
    thousandSeparator,
    decimalSeparator
  } = polycardStore.usePolycardContext();
  const styleProps = polycardStore._extends({
    color: no_interest ? 'positive' : 'primary'
  }, styles);
  if (!thousandSeparator || !decimalSeparator) {
    // eslint-disable-next-line no-console
    console.error(polycardStore.MsgThousandDecimalError);
    return null;
  }
  return jsxRuntime.jsx(phrase.Phrase, {
    text: text,
    thousandSeparator: thousandSeparator,
    decimalSeparator: decimalSeparator,
    styles: styleProps,
    values: values,
    className: className
  });
};
const namespace$7 = `${cardNamespace}-installments__options`;
const InstallmentsOptions = _ref => {
  let {
    installments_options,
    className
  } = _ref;
  return jsxRuntime.jsx("div", {
    className: className,
    children: installments_options == null ? void 0 : installments_options.map(props => (/*#__PURE__*/React.createElement(InstallmentsPrice, polycardStore._extends({
      className: namespace$7
    }, props, {
      key: props.text
    }))))
  });
};
const _excluded$1 = ["children", "className"];
const Pill = _ref => {
  let {
      children,
      className: namespace
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  const {
    thousandSeparator,
    decimalSeparator
  } = polycardStore.usePolycardContext();
  return jsxRuntime.jsxs("div", {
    className: `${namespace}__wrapper`,
    children: [jsxRuntime.jsx(phrase.Phrase, polycardStore._extends({}, props, {
      className: `${namespace}__pill`,
      decimalSeparator: decimalSeparator,
      iconClassName: `${namespace}__icon`,
      thousandSeparator: thousandSeparator
    })), children]
  });
};
const Pills = _ref => {
  let {
    pills,
    type,
    className
  } = _ref;
  const namespace = `${cardNamespace}-${type}`;
  return jsxRuntime.jsx("div", {
    className: className,
    children: pills == null ? void 0 : pills.map(pill => {
      var _finalPillprops$text;
      const {
        discount,
        discount_time
      } = pill;
      const finalPillprops = discount ? polycardStore._extends({}, discount) : polycardStore._extends({}, pill);
      return /*#__PURE__*/React.createElement(Pill, polycardStore._extends({}, finalPillprops, {
        className: namespace,
        key: (_finalPillprops$text = finalPillprops.text) == null ? void 0 : _finalPillprops$text.toLowerCase().replace(' ', '-')
      }), discount_time && jsxRuntime.jsx(BlockText, polycardStore._extends({}, discount_time, {
        className: `${namespace}__label`
      })));
    })
  });
};
const CurrentPrice = _ref => {
  let {
    value,
    size,
    currency,
    decimal_style = 'superscript',
    suffix,
    symbol
  } = _ref;
  const {
    thousandSeparator,
    decimalSeparator,
    isMobile,
    card_size
  } = polycardStore.usePolycardContext();
  const fontSize = React.useMemo(() => {
    const fontSizeMap = {
      small: 16,
      medium: 16,
      mobile: 20,
      large: 24
    };
    if (size) return size;
    if (card_size !== 'large') return fontSizeMap[card_size];
    return isMobile ? fontSizeMap['mobile'] : fontSizeMap['large'];
  }, [size, card_size, isMobile]);
  if (!thousandSeparator || !decimalSeparator) {
    // eslint-disable-next-line no-console
    console.error(polycardStore.MsgThousandDecimalError);
    return null;
  }
  const priceAmountProps = {
    value,
    currency,
    decimal_style,
    size: fontSize,
    thousandSeparator,
    decimalSeparator,
    suffix,
    symbol
  };
  return jsxRuntime.jsx(priceAmount.PriceAmount, polycardStore._extends({}, priceAmountProps));
};
const DiscountPrice = _ref => {
  let {
    size,
    value,
    className
  } = _ref;
  const {
    isMobile,
    card_size
  } = polycardStore.usePolycardContext();
  const fontSize = React.useMemo(() => {
    const fontSizeMap = {
      small: 10,
      medium: 12,
      mobile: 12,
      large: 14
    };
    if (size) return size;
    if (card_size !== 'large') return fontSizeMap[card_size];
    return isMobile ? fontSizeMap['mobile'] : fontSizeMap['large'];
  }, [size, card_size, isMobile]);
  return jsxRuntime.jsx(moneyAmount.MoneyAmountDiscount, {
    className: className,
    size: fontSize,
    value: value
  });
};
const previous = true;
const PreviousPrice = _ref => {
  let {
    value,
    size,
    currency,
    decimal_style
  } = _ref;
  const {
    thousandSeparator,
    decimalSeparator
  } = polycardStore.usePolycardContext();
  if (!thousandSeparator || !decimalSeparator) {
    // eslint-disable-next-line no-console
    console.error(polycardStore.MsgThousandDecimalError);
    return null;
  }
  const priceAmountProps = {
    value,
    currency,
    decimal_style,
    size: size != null ? size : 12,
    previous,
    thousandSeparator,
    decimalSeparator
  };
  return jsxRuntime.jsx(priceAmount.PriceAmount, polycardStore._extends({}, priceAmountProps));
};
const namespace$6 = `${cardNamespace}-price`;
const Price = _ref => {
  let {
    price_to_agree,
    discount,
    discount_label,
    current_price,
    previous_price,
    installments,
    price_detail,
    prefix,
    className
  } = _ref;
  return jsxRuntime.jsxs("div", {
    className: className,
    children: [price_to_agree ? jsxRuntime.jsx(BlockText, polycardStore._extends({}, price_to_agree, {
      className: classnames__default["default"](`${namespace$6}__agree`)
    })) : null, prefix ? jsxRuntime.jsx(BlockText, polycardStore._extends({}, prefix, {
      className: classnames__default["default"](`${namespace$6}__prefix`)
    })) : null, previous_price ? jsxRuntime.jsx(PreviousPrice, polycardStore._extends({}, previous_price)) : null, current_price ? jsxRuntime.jsxs("div", {
      className: classnames__default["default"](`${namespace$6}__current`),
      children: [jsxRuntime.jsx(CurrentPrice, polycardStore._extends({}, current_price)), discount_label ? jsxRuntime.jsx(BlockText, polycardStore._extends({}, discount_label, {
        className: classnames__default["default"]('andes-money-amount__discount', `${namespace$6}__disc_label`)
      })) : null, discount ? jsxRuntime.jsx(DiscountPrice, polycardStore._extends({}, discount)) : null]
    }) : null, price_detail ? jsxRuntime.jsx(BlockText, polycardStore._extends({}, price_detail, {
      className: classnames__default["default"](`${namespace$6}__price-detail`)
    })) : null, installments ? jsxRuntime.jsx(InstallmentsPrice, polycardStore._extends({}, installments, {
      className: classnames__default["default"](`${namespace$6}__installments`)
    })) : null]
  });
};
const Icons = ['icon_star', 'icon_star_half', 'icon_star_fill'];
const getNumTotal = total => Math.abs(Math.trunc(typeof total === 'number' ? total : 0));
const getTextIconByMapper = index => `{${Icons[index]}}`;
const fractionalPart = rating => Math.floor(10 * rating - 10 * Math.floor(rating)) / 10; // cause numerical errors by divider number almost equals
const getTruncAndRound = rating => [Math.floor, fractionalPart].map(item => item(rating));
const getValueIconByMapper = index => {
  const isAriaHidden = true;
  const type = 'icon';
  const preKey = index === 1 ? '_half' : '';
  const key = `icon_star${index === 2 ? '_fill' : preKey}`;
  const icon = {
    key: `star${index === 2 ? '_fill' : preKey}`,
    area_hidden: isAriaHidden
  };
  return {
    type,
    key,
    icon
  };
};
const validRating = rating => {
  if (typeof rating !== 'number') return 0;
  const validRatingValue = Math.min(5, Math.max(0, Number(rating)));
  return validRatingValue;
};
const getMapperArray = rating => {
  const [truncated, fractional] = getTruncAndRound(rating);
  return Array.from({
    length: 5
  }, (_, index) => {
    if (index < truncated) return 2;
    if (index === truncated) {
      if (fractional <= 0.2) return 0;
      return fractional > 0.7 ? 2 : 1;
    }
    return 0;
  });
};
const getTextValues = rating_average => {
  const ratings = [0, 1, 2];
  const rating = validRating(rating_average);
  const mapperArray = getMapperArray(rating);
  const text = mapperArray.map(item => getTextIconByMapper(item)).join(' ');
  const value = ratings.filter(item => mapperArray.some(el => item === el)).map(item => getValueIconByMapper(item));
  return [text, value];
};
const getRatingAverage = rating_average => {
  const rating = validRating(rating_average);
  return rating % 1 === 0 ? `${rating}.0` : `${rating}`;
};
const namespace$5 = `${cardNamespace}-reviews`;
const MemoizedPhrase = /*#__PURE__*/React__default["default"].memo(phrase.Phrase);
const Reviews = _ref => {
  let {
    className,
    rating_average,
    total,
    alt_text
  } = _ref;
  const [text, values] = React.useMemo(() => getTextValues(rating_average), [rating_average]);
  const num_total = getNumTotal(total);
  const ratingAverage = getRatingAverage(rating_average);
  return jsxRuntime.jsxs("div", {
    className: className,
    children: [jsxRuntime.jsx("span", {
      className: "andes-visually-hidden",
      children: alt_text
    }), jsxRuntime.jsx("span", {
      className: classnames__default["default"](`${namespace$5}__rating`),
      "aria-hidden": "true",
      children: ratingAverage
    }), jsxRuntime.jsx(MemoizedPhrase, {
      text,
      values,
      className: classnames__default["default"](`${namespace$5}__starts`)
    }, rating_average), jsxRuntime.jsx("span", {
      className: classnames__default["default"](`${namespace$5}__total`),
      "aria-hidden": "true",
      children: `(${num_total})`
    })]
  });
};
const namespace$4 = `${cardNamespace}-shipping`;
const Shipping = _ref => {
  let {
    text,
    styles,
    values,
    className,
    promise_type = 'none',
    icon,
    alt_text,
    additional_text
  } = _ref;
  const isPromise = promise_type && promise_type !== 'none';
  const shippingClases = classnames__default["default"]({
    [`${namespace$4}--${promise_type}`]: isPromise
  });
  const iconClasses = classnames__default["default"]({
    [`${namespace$4}__promise-icon--meli-plus`]: icon == null ? void 0 : icon.key.includes('plus'),
    [`${namespace$4}__promise-icon--full-super`]: icon == null ? void 0 : icon.key.includes('super'),
    [`${namespace$4}__promise-icon--full`]: !(icon != null && icon.key.includes('plus')) && !(icon != null && icon.key.includes('super'))
  });
  const iconValues = icon ? [polycardStore._extends({}, !!icon && {
    key: icon.key,
    type: 'icon',
    icon: {
      aria_label: icon == null ? void 0 : icon.alt_text,
      key: icon == null ? void 0 : icon.key,
      src: icon == null ? void 0 : icon.src
    }
  })] : [];
  const phrase$1 = () => jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [text && jsxRuntime.jsx(phrase.Phrase, {
      text: text,
      values: values,
      styles: styles,
      className: shippingClases || undefined,
      aria_label: alt_text || undefined,
      isAsText: isPromise || !!icon
    }), icon && jsxRuntime.jsx(phrase.Phrase, {
      text: `{${icon.key}}`,
      values: iconValues,
      iconClassName: iconClasses,
      isAsText: false
    }), additional_text && jsxRuntime.jsx(phrase.Phrase, {
      text: additional_text,
      className: `${namespace$4}__additional_text`
    })]
  });
  return jsxRuntime.jsx("div", polycardStore._extends({
    className: className
  }, alt_text && {
    'aria-label': alt_text
  }, {
    children: phrase$1()
  }));
};
const Title = _ref => {
  let {
    title_tag,
    long_title,
    className,
    values,
    styles,
    text
  } = _ref;
  const {
    targetLink,
    target
  } = polycardStore.usePolycardContext();
  const {
    url,
    onClick
  } = useCardContext();
  const resolvedTarget = target != null ? target : targetLink;
  const titleClassName = classnames__default["default"](className, {
    [`${className}--long`]: long_title
  });
  return jsxRuntime.jsx(phrase.Phrase, polycardStore._extends({
    text: text,
    url: url,
    styles: styles,
    values: values,
    className: titleClassName,
    target: url ? resolvedTarget : undefined,
    onClick: onClick,
    asBox: title_tag,
    boxClassName: title_tag ? `${className}-wrapper` : undefined
  }, !url && !title_tag && {
    asText: 'p'
  }));
};
const VariationItem = _ref => {
  let {
    pictures,
    picture_size,
    variation_id,
    description,
    url_product,
    url_params: variationParams,
    url_fragments,
    sanitized_title
  } = _ref;
  const namespace = 'poly-variations__item';
  const {
    isNavigableToVariation,
    url_prefix,
    url_params_default,
    url_fragments_default
  } = polycardStore.usePolycardContext();
  const {
    setPicturesSelected,
    variationSelected,
    setVariationSelected,
    pickerAction,
    metadata
  } = useCardContext();
  const urlVariations = getUrl(metadata, variationParams, url_prefix, url_params_default, url_fragments_default, url_fragments, url_product);
  const handleVariationSelect = React.useCallback(() => {
    if (setPicturesSelected && !pickerAction) {
      const updatedPictures = pictures.map(picture => polycardStore._extends({}, picture, {
        lazyload: pictures.length === 1 ? false : picture == null ? void 0 : picture.lazyload
      }));
      setPicturesSelected(updatedPictures);
    }
    if (pickerAction) {
      pickerAction(variation_id);
    }
    if (setVariationSelected) {
      setVariationSelected(variation_id);
    }
  }, [setPicturesSelected, pickerAction, pictures, variation_id, setVariationSelected]);
  const itemClasses = classnames__default["default"](namespace, {
    [`${namespace}--active`]: variation_id === variationSelected
  });
  return jsxRuntime.jsx("li", {
    className: itemClasses,
    children: jsxRuntime.jsx("a", polycardStore._extends({}, !isNavigableToVariation ? {
      onClick: handleVariationSelect
    } : {
      href: urlVariations
    }, {
      role: "button",
      "aria-label": description,
      className: "poly-variations__anchor",
      children: !!pictures && jsxRuntime.jsx(Picture, {
        id: pictures[0].id,
        size: picture_size,
        alt: description,
        sanitized_title: sanitized_title
      })
    }))
  }, `variation-item-${variation_id}`);
};
const VariationPicker = _ref => {
  let {
    text,
    variations,
    picture_size,
    total_variations
  } = _ref;
  const namespace = 'poly-variations-picker';
  const item_namespace = 'poly-variations__item';
  const {
    isMobile,
    card_size
  } = polycardStore.usePolycardContext();
  const {
    setLabelPill,
    url
  } = useCardContext();
  // Calcular el ancho del ítem, el ancho de un item + margin es 52px en mobile, 46px en desktop, 48 para small y medium
  const itemWidth = React.useMemo(() => {
    const itemWidthMap = {
      small: 48,
      medium: 50,
      mobile: 52,
      large: 46
    };
    const widthByCardSize = card_size !== 'large' ? itemWidthMap[card_size] : null;
    return widthByCardSize || (isMobile ? itemWidthMap['mobile'] : itemWidthMap['large']);
  }, [card_size, isMobile]);
  const contenedorRef = React.useRef(null);
  const [needExtraItem, setNeedExtraItem] = React.useState(false);
  const [variationsToRender, setVariationsToRender] = React.useState(0);
  const [variationsGroup, setvariationsGroup] = React.useState([]);
  React.useEffect(() => {
    if (contenedorRef.current) {
      const variationsInClientWidth = Math.floor((contenedorRef.current.clientWidth - 10) / itemWidth);
      const isSpaceEnough = !!total_variations && total_variations <= variationsInClientWidth;
      setVariationsToRender(isSpaceEnough ? variationsInClientWidth : variationsInClientWidth - 1);
      setNeedExtraItem(!isSpaceEnough);
    }
  }, [itemWidth, total_variations, contenedorRef]);
  React.useEffect(() => {
    const newVariationsGroup = (variations != null ? variations : []).map((_ref2, index) => {
      let {
        pictures,
        variation_id,
        description,
        url: url_product,
        url_params,
        url_fragments,
        sanitized_title
      } = _ref2;
      if (index > variationsToRender - 1) {
        return null;
      }
      const variationProps = {
        pictures,
        picture_size,
        variation_id,
        description,
        url_product,
        url_params,
        url_fragments,
        sanitized_title
      };
      return /*#__PURE__*/React.createElement(VariationItem, polycardStore._extends({}, variationProps, {
        key: `variation-picker-${variation_id}`
      }));
    }).filter(Boolean);
    setvariationsGroup(newVariationsGroup);
  }, [needExtraItem, picture_size, variations, variationsToRender]);
  React.useEffect(() => {
    if (text && setLabelPill) {
      setLabelPill(text);
    }
  }, [text, setLabelPill]);
  return variations && jsxRuntime.jsxs("ul", {
    className: namespace,
    ref: contenedorRef,
    children: [variationsGroup, variationsGroup && needExtraItem && jsxRuntime.jsx("li", {
      className: item_namespace,
      children: jsxRuntime.jsx(Link, {
        url: url,
        classModified: "variations",
        children: `+${(total_variations != null ? total_variations : 0) - variationsGroup.length}`
      })
    }, "variation-picker-extra")]
  });
};
const VariationSelect = _ref => {
  let {
    text,
    variations,
    picture_size,
    total_variations
  } = _ref;
  const {
    setPicturesSelected,
    variationSelected,
    setVariationSelected,
    url,
    metadata
  } = useCardContext();
  const {
    isNavigableToVariation,
    url_prefix,
    url_params_default,
    url_fragments_default
  } = polycardStore.usePolycardContext();
  const namespace = 'poly-variations-select';
  const item_namespace = 'poly-variations__item';
  const wrapperVariation = isNavigableToVariation ? 'a' : React__default["default"].Fragment;
  const WrapperTag = wrapperVariation;
  const maxVariations = 6;
  const hasMoreVariations = !!total_variations && total_variations > ((variations == null ? void 0 : variations.length) || 0);
  const [description, setDescription] = React.useState();
  React.useEffect(() => {
    if (variations) {
      var _variations$find;
      setDescription((_variations$find = variations.find(_ref2 => {
        let {
          variation_id: id
        } = _ref2;
        return id === variationSelected;
      })) == null ? void 0 : _variations$find.description);
    }
  }, [variations, variationSelected]);
  const variationUrls = (variations != null ? variations : []).map(_ref3 => {
    let {
      variation_id,
      url_params: variationParams,
      url_fragments,
      url: url_product
    } = _ref3;
    return {
      variation_id,
      url: getUrl(metadata, variationParams, url_prefix, url_params_default, url_fragments_default, url_fragments, url_product)
    };
  });
  const handleVariationSelect = variationId => {
    const variation = variations == null ? void 0 : variations.find(_ref4 => {
      let {
        variation_id: id
      } = _ref4;
      return id === variationId;
    });
    if (variation) {
      if (setPicturesSelected) {
        setPicturesSelected(variation.pictures.map(picture => polycardStore._extends({}, picture, {
          lazyload: variation.pictures.length === 1 ? false : picture == null ? void 0 : picture.lazyload
        })));
      }
      if (setVariationSelected) {
        setVariationSelected(variation.variation_id);
      }
    }
  };
  const dropDownOptions = () => {
    const options = (variations != null ? variations : []).map((_ref5, index) => {
      var _variationUrls$find, _variations$length;
      let {
        variation_id,
        pictures,
        description: itemDescription,
        sanitized_title
      } = _ref5;
      const urlVariation = (_variationUrls$find = variationUrls.find(_ref6 => {
        let {
          variation_id: id
        } = _ref6;
        return id === variation_id;
      })) == null ? void 0 : _variationUrls$find.url;
      if (hasMoreVariations && index + 1 >= maxVariations && index === ((_variations$length = variations == null ? void 0 : variations.length) != null ? _variations$length : 0) - 1) {
        return null;
      }
      return jsxRuntime.jsx(list.ListItem, {
        value: variation_id,
        className: classnames__default["default"](item_namespace),
        "aria-label": itemDescription,
        children: !!pictures && jsxRuntime.jsx(WrapperTag, polycardStore._extends({}, isNavigableToVariation && {
          href: urlVariation,
          className: 'poly-variations__anchor'
        }, {
          children: jsxRuntime.jsx(Picture, {
            id: pictures[0].id,
            size: picture_size,
            alt: itemDescription,
            sanitized_title: sanitized_title
          })
        }))
      }, `variation-select-${variation_id}`);
    });
    if (hasMoreVariations && options) {
      const extraItemLable = `+${total_variations - options.filter(Boolean).length}`;
      options.push(jsxRuntime.jsx(list.ListItem, {
        className: "poly-variations__item",
        "aria-label": extraItemLable,
        children: jsxRuntime.jsx(Link, {
          url: url,
          classModified: "variations",
          children: extraItemLable
        })
      }, "variation-select-extra"));
    }
    return options.filter(Boolean);
  };
  return description && jsxRuntime.jsxs("div", {
    className: `${namespace}`,
    children: [jsxRuntime.jsx("p", {
      className: `${namespace}__label`,
      children: `${text}:`
    }), jsxRuntime.jsx(dropdown.DropdownStandalone, {
      className: `${namespace}__dropdown`,
      label: description,
      value: variationSelected,
      menuAlignment: "bottom",
      onChange: (e, variationId) => typeof variationId === 'string' && !isNavigableToVariation && handleVariationSelect(variationId),
      children: dropDownOptions()
    })]
  });
};
const Variations = _ref => {
  let {
    className,
    text,
    variations,
    picture_size,
    total_variations
  } = _ref;
  const {
    type,
    isMobile,
    card_size
  } = polycardStore.usePolycardContext();
  const {
    setVariationSelected
  } = useCardContext();
  const props = {
    variations,
    text,
    picture_size,
    total_variations
  };
  React.useEffect(() => {
    if (setVariationSelected && variations != null && variations.length) {
      setVariationSelected(variations[0].variation_id);
    }
  }, [setVariationSelected, variations]);
  return jsxRuntime.jsx("div", {
    className: className,
    children: type != null && type.includes('list') && !isMobile && card_size === 'large' ? jsxRuntime.jsx(VariationSelect, polycardStore._extends({}, props)) : jsxRuntime.jsx(VariationPicker, polycardStore._extends({}, props))
  });
};

// Definimos una constante que es un objeto que asigna cada tipo de componente (ComponentType) a una clave de propiedad correspondiente en un arreglo de objetos (ComponentInterface[]).
// Ejemplo con esto podemos acceder a la propiedad 'shipping' de un componente de tipo 'shipping' de la siguiente manera: componentTypeToPropKey['shipping']
const componentTypeToPropKey = {
  action_links: 'action_links',
  add_to_cart: 'add_to_cart',
  attributes_list: 'attributes_list',
  available_units: 'available_units',
  brand: 'brand',
  buy_box: 'buy_box',
  cbt: 'cbt',
  compats: 'compats',
  coupons: 'coupons',
  cpg: 'cpg',
  headline: 'headline',
  highlight: 'highlight',
  installation_services: 'installation_services',
  installments_options: 'installments_options',
  item_condition: 'item_condition',
  label: 'label',
  last_available: 'last_available',
  location: 'location',
  manufacturing_time: 'manufacturing_time',
  meli_coin: 'meli_coin',
  paused: 'paused',
  pill: 'pill',
  possession_date: 'possession_date',
  price_per_quantity: 'price_per_quantity',
  price: 'price',
  promotions: 'promotions',
  purchase_options: 'purchase_options',
  rebates: 'rebates',
  reviews: 'reviews',
  seller: 'seller',
  shipped_from: 'shipped_from',
  shipping: 'shipping',
  title: 'title',
  trade_in: 'trade_in',
  variations_text: 'variations_text',
  variations: 'variations',
  visit_history: 'visit_history',
  visit_request: 'visit_request'
  // aca van los nuevos nombres de componentes como se esperan en el contrato
};
// Esta constante es un objeto que asigna cada tipo de componente (ComponentType) a un componente de React espesifico como title : <Title>
// Estamos utilizando as FC<ComponentProps<ComponentType>> para asegurarnos de que Title coincida con el tipado esperado de FC<ComponentProps<ComponentType>> que sera TitleProps
const ComponentsList = {
  action_links: ActionLinks,
  add_to_cart: AddToCart,
  attributes_list: AttributesList,
  available_units: BlockText,
  brand: BlockText,
  buy_box: BuyBox,
  cbt: BlockText,
  cpg: BlockText,
  compats: BlockText,
  installation_services: BlockText,
  coupons: Pills,
  shipped_from: BlockText,
  headline: BlockText,
  highlight: BlockText,
  installments_options: InstallmentsOptions,
  item_condition: BlockText,
  label: BlockText,
  last_available: BlockText,
  location: BlockText,
  manufacturing_time: BlockText,
  meli_coin: Pills,
  paused: BlockText,
  pill: Pills,
  possession_date: BlockText,
  price_per_quantity: Pills,
  price: Price,
  promotions: Pills,
  purchase_options: BlockText,
  rebates: Pills,
  reviews: Reviews,
  seller: BlockText,
  shipping: Shipping,
  title: Title,
  trade_in: BlockText,
  variations_text: BlockText,
  variations: Variations,
  visit_history: BlockText,
  visit_request: BlockText
  // aca van los nuevos <Componentes> as FC<ComponentProps<ComponentType>>,
};
const _excluded = ["type"],
  _excluded2 = ["type"];
const namespace$3 = 'poly-component';
const ListComponents = _ref => {
  let {
    components
  } = _ref;
  const {
    metadata: {
      id
    }
  } = useCardContext();
  if (components.length === 0) return null;
  const typeMapping = {
    coupon: 'coupons',
    rebate: 'rebates',
    pill: 'pill',
    label: 'label'
  };
  return jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: components.map(component => {
      const key = getKey(component, id);
      const {
          type
        } = component,
        props = _objectWithoutPropertiesLoose(component, _excluded);
      const propKey = componentTypeToPropKey[type];
      if (propKey && propKey in props && 'type' in component) {
        var _componentPropsToPass;
        // separa las promociones en componentes pills o labels individuales segun su type y renderiza cada componente
        // pill = type (coupon, rebate, pill, price_per_quantity, meli_coin )
        // lable = type label
        if (component.type === 'promotions') {
          var _component$promotions;
          return (_component$promotions = component.promotions) == null ? void 0 : _component$promotions.map(_ref2 => {
            let {
                type: promotionType
              } = _ref2,
              promotionProps = _objectWithoutPropertiesLoose(_ref2, _excluded2);
            let PromotionComponent = ComponentsList['pill'];
            let promotionComponentProps = {};
            if (['coupon', 'rebate', 'pill'].includes(promotionType)) {
              promotionComponentProps = {
                pills: [promotionProps],
                type: typeMapping[promotionType]
              };
            } else if (['label'].includes(promotionType)) {
              PromotionComponent = ComponentsList['label'];
              promotionComponentProps = polycardStore._extends({}, promotionProps);
            }
            return jsxRuntime.jsx(PromotionComponent, polycardStore._extends({}, promotionComponentProps, {
              className: `${namespace$3}__${typeMapping[promotionType].replace(/_/g, '-')}`
            }), key + promotionType);
          });
        }
        // Obtenemos el componente correspondiente según el tipo
        const Component = ComponentsList[type];
        // Obtenemos los props del componente según el propKey
        const componentProps = props[propKey];
        // Inicializamos componentPropsToPass con los props del componente, esto con el fin de poder modificar componentPropsToPass en caso de ser necesario (lo es en los arreglos)
        let componentPropsToPass = componentProps;
        // Verificamos si se necesita modificar componentPropsToPass, para los casos donde se esperan arreglos y no objetos
        if (component.type === 'action_links' || component.type === 'installments_options') {
          componentPropsToPass = {
            [component.type]: componentProps
          };
        }
        // convertimos en arreglo los compoentes que comparten pill
        if (component.type === 'coupons' || component.type === 'rebates' || component.type === 'pill' || component.type === 'price_per_quantity' || component.type === 'meli_coin') {
          const pillsprops = {
            pills: Array.isArray(componentProps) ? componentProps : [componentProps],
            type: component.type
          };
          componentPropsToPass = pillsprops;
        }
        const componentClassName = classnames__default["default"](`${namespace$3}__${component.type.replace(/_/g, '-')}`, {
          [(_componentPropsToPass = componentPropsToPass) == null ? void 0 : _componentPropsToPass.class_name]: Object.prototype.hasOwnProperty.call(componentPropsToPass, 'class_name')
        });
        return jsxRuntime.jsx(Component, polycardStore._extends({}, componentPropsToPass, {
          className: componentClassName
        }), key);
      }
      // Si propKey no es una propiedad válida, devolvemos null
      return null;
    })
  });
};
const namespace$2 = `${cardNamespace}-component__badge`;
const Badge = _ref => {
  let {
    src,
    className,
    alt_text,
    values,
    text
  } = _ref;
  const {
    url
  } = useCardContext();
  const Component = src ? Picture : phrase.Phrase;
  const badgeClasess = classnames__default["default"](className, namespace$2, {
    [`${namespace$2}--image`]: !!src
  });
  return jsxRuntime.jsx(Link, {
    className: badgeClasess,
    url: url,
    children: jsxRuntime.jsx(Component, polycardStore._extends({}, src ? {
      id: 'badge',
      src,
      alt: alt_text
    } : {
      text,
      isAsText: false,
      values
    }))
  });
};
const namespace$1 = `${cardNamespace}-component__float-highlight`;
const FloatHighlight = _ref => {
  let {
    className,
    styles,
    text,
    values
  } = _ref;
  const {
    url
  } = useCardContext();
  const handleClick = () => {
    if (url) {
      window.location.href = url;
    }
  };
  const floatHighlightClassName = classnames__default["default"](namespace$1, {
    [`${className}`]: className
  });
  return jsxRuntime.jsx(phrase.Phrase, {
    className: floatHighlightClassName,
    styles: styles,
    text: text,
    values: values,
    onClick: handleClick
  });
};
const namespace = `${cardNamespace}-card`;
const Card = _ref => {
  var _polycard$components$, _pictures$pictures, _variationsComponent$, _polycard$pictures, _polycard$pictures2, _polycard$pictures3, _col1Props$components;
  let {
    as,
    bookmarkAction,
    addToCartActions,
    cardNumber,
    checkbox: checkboxComponent,
    className,
    onClick,
    onMouseEnter,
    onMouseLeave,
    pickerAction,
    polycard,
    styles,
    useLazyImage,
    suggestions,
    onAfterImageChange
  } = _ref;
  const {
    debug_info,
    type,
    isMobile,
    isTablet,
    checkbox,
    card_size,
    deviceType,
    action_links,
    url_prefix,
    url_params_default,
    url_fragments_default,
    isNavigableToVariation
  } = polycardStore.usePolycardContext();
  const {
    metadata,
    bookmark,
    featured,
    ads_promotions,
    tour_virtual,
    seller_logo,
    pictures,
    unique_id,
    float_highlight,
    badge
  } = polycard;
  const {
    vertical_id,
    image_ratio,
    image_square
  } = metadata;
  const {
    isGrid,
    isSingle,
    isList,
    isTwoCols,
    isListHeight,
    isGridHeight,
    isCarousel,
    isDesktop,
    squareMobile,
    Imagewrapper,
    shouldDisplayLabelPill
  } = useEvaluationsCard({
    type,
    isMobile,
    isTablet,
    deviceType,
    image_ratio,
    pictures,
    image_square,
    vertical_id,
    card_size
  });
  const [isHover, setIsHover] = React.useState(false);
  const [needSuggestions, setNeedSuggestions] = React.useState(false);
  const [labelPill, setLabelPill] = React.useState(null);
  const [variationSelected, setVariationSelected] = React.useState();
  const [debugToolModule, setDebugToolModule] = React.useState(null);
  const [colProps, col1Props, col2Props] = getColProps(isTwoCols, polycard.components);
  const badgeProps = seller_logo || badge;
  const hasActionLinksComponent = polycard.components.some(_ref2 => {
    let {
      type: typeComponent
    } = _ref2;
    return typeComponent === 'action_links';
  });
  const variationsComponent = polycard.components.find(_ref3 => {
    let {
      type: typeComponent
    } = _ref3;
    return typeComponent === 'variations';
  });
  const titleText = (_polycard$components$ = polycard.components.find(_ref4 => {
    let {
      type: typeComponent
    } = _ref4;
    return typeComponent === 'title';
  })) == null || (_polycard$components$ = _polycard$components$.title) == null ? void 0 : _polycard$components$.text;
  const [picturesSelected, setPicturesSelected] = React.useState((_pictures$pictures = pictures == null ? void 0 : pictures.pictures) != null ? _pictures$pictures : []);
  const filteredVariations = isNavigableToVariation ? undefined : variationsComponent == null || (_variationsComponent$ = variationsComponent.variations) == null ? void 0 : _variationsComponent$.variations.find(_ref5 => {
    let {
      variation_id
    } = _ref5;
    return variation_id === variationSelected;
  });
  const variationParams = filteredVariations == null ? void 0 : filteredVariations.url_params;
  const variationsFragments = filteredVariations == null ? void 0 : filteredVariations.url_fragments;
  const cardUrl = getUrl(metadata, variationParams, url_prefix, url_params_default, url_fragments_default, variationsFragments);
  React.useEffect(() => {
    if (pictures != null && pictures.pictures) setPicturesSelected(pictures == null ? void 0 : pictures.pictures);
  }, [pictures == null ? void 0 : pictures.pictures]);
  const handlerOnmouseEnter = () => {
    setIsHover(true);
    if (onMouseEnter) {
      onMouseEnter();
    }
  };
  const handlerOnmouseLeave = () => {
    setIsHover(false);
    if (onMouseLeave) {
      onMouseLeave();
    }
  };
  const mainClassName = classnames__default["default"](className, `${namespace}`, `${namespace}--${type === 'list-multicolumn' ? 'list' : type}`, {
    [`${namespace}--${card_size}`]: card_size,
    [`${namespace}--mobile`]: card_size === `large` && isMobile,
    [`${namespace}--tablet`]: card_size === `large` && isTablet,
    [`${namespace}--hover`]: isHover,
    [`${namespace}--checkbox`]: !!checkbox && !!checkboxComponent && !isMobile && (type === 'list' || type === 'list-multicolumn'),
    [`${namespace}--${vertical_id}`]: vertical_id
  });
  React.useEffect(() => {
    if (debug_info) {
      Promise.resolve().then(function () {
        return require('./debug-tool-f9954db3.cjs');
      }).then(module => {
        setDebugToolModule(module);
      }).catch(error => {
        // eslint-disable-next-line no-console
        console.error('Error al importar la librería:', error);
      });
    }
  }, [debug_info]);
  return jsxRuntime.jsxs(CardContext, {
    contextValue: {
      addToCartActions,
      bookmark: polycardStore._extends({}, bookmark, {
        bookmarkAction
      }),
      cardNumber,
      checkbox: checkboxComponent,
      isHover,
      metadata,
      needSuggestions,
      onClick,
      pickerAction,
      picturesSelected,
      setLabelPill,
      setNeedSuggestions,
      setPicturesSelected,
      setVariationSelected,
      suggestions,
      title: titleText,
      url: cardUrl,
      useLazyImage,
      variationSelected,
      onAfterImageChange
    },
    children: [jsxRuntime.jsxs(Layout, polycardStore._extends({
      className: mainClassName,
      styles: styles,
      as: as
    }, isDesktop && {
      onMouseEnter: handlerOnmouseEnter
    }, isDesktop && {
      onMouseLeave: handlerOnmouseLeave
    }, {
      children: [jsxRuntime.jsxs("div", {
        className: classnames__default["default"](`${namespace}__portada`, {
          [`${namespace}__portada--no-line`]: !!variationSelected,
          [`${namespace}__portada--list-height`]: isListHeight && !isCarousel,
          [`${namespace}__portada--grid-height`]: isGridHeight
        }),
        children: [!!polycard && !!polycard.pictures && !!picturesSelected && jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [float_highlight && jsxRuntime.jsx(FloatHighlight, polycardStore._extends({}, float_highlight)), jsxRuntime.jsx(ImagesContainer, {
            alt_text: polycard.pictures.alt_text,
            Imagewrapper: Imagewrapper,
            isCarousel: isCarousel,
            isListHeight: isListHeight,
            overlay: (_polycard$pictures = polycard.pictures) == null ? void 0 : _polycard$pictures.overlay,
            pictures: picturesSelected,
            sanitized_title: (_polycard$pictures2 = polycard.pictures) == null ? void 0 : _polycard$pictures2.sanitized_title,
            size: polycard.pictures.size,
            square: squareMobile || (polycard == null || (_polycard$pictures3 = polycard.pictures) == null ? void 0 : _polycard$pictures3.square)
          })]
        }), !isHover && labelPill && shouldDisplayLabelPill && !isTablet && jsxRuntime.jsx("span", {
          className: classnames__default["default"](`${namespace}__label-pill`),
          children: labelPill
        }), badgeProps && jsxRuntime.jsx(Badge, polycardStore._extends({}, badgeProps))]
      }), debugToolModule && debug_info && jsxRuntime.jsx(debugToolModule.DebugTool, {
        polycard: polycard
      }), jsxRuntime.jsxs("div", {
        className: `${namespace}__content`,
        children: [jsxRuntime.jsx(ListComponents, polycardStore._extends({}, colProps)), col1Props.components && ((_col1Props$components = col1Props.components) == null ? void 0 : _col1Props$components.length) > 0 && jsxRuntime.jsxs("div", {
          className: "poly-content",
          children: [jsxRuntime.jsx("div", {
            className: classnames__default["default"]('poly-content__column'),
            children: jsxRuntime.jsx(ListComponents, polycardStore._extends({}, col1Props))
          }), jsxRuntime.jsx("div", {
            className: classnames__default["default"]('poly-content__column'),
            children: jsxRuntime.jsx(ListComponents, polycardStore._extends({}, col2Props))
          })]
        }), !hasActionLinksComponent && action_links && action_links.length > 0 && jsxRuntime.jsx(ActionLinks, {
          className: "poly-component__action-links",
          action_links: action_links
        }, "action_links"), isList && (ads_promotions || featured || tour_virtual) && jsxRuntime.jsxs("div", {
          className: `${cardNamespace}-footer`,
          children: [tour_virtual && (/*#__PURE__*/React.createElement(BlockText, polycardStore._extends({}, tour_virtual, {
            key: tour_virtual && 'tour_virtual',
            className: classnames__default["default"]({
              'poly-component__tour-virtual': !!tour_virtual
            }),
            text: (tour_virtual == null ? void 0 : tour_virtual.text) || ''
          }))), (featured || ads_promotions) && (/*#__PURE__*/React.createElement(BlockText, polycardStore._extends({}, ads_promotions || featured, {
            key: ads_promotions && 'ads_promotions' || featured && 'featured',
            className: classnames__default["default"]({
              'poly-component__ads-promotions': !!ads_promotions,
              'poly-component__featured': !!featured
            }),
            text: (ads_promotions == null ? void 0 : ads_promotions.text) || (featured == null ? void 0 : featured.text) || ''
          })))]
        })]
      }), (isGrid || isSingle) && (ads_promotions || featured || tour_virtual) && jsxRuntime.jsxs("div", {
        className: `${namespace}__footer`,
        children: [tour_virtual && (/*#__PURE__*/React.createElement(BlockText, polycardStore._extends({}, tour_virtual, {
          key: tour_virtual && 'tour_virtual',
          className: classnames__default["default"]({
            'poly-component__tour-virtual': !!tour_virtual
          }),
          text: (tour_virtual == null ? void 0 : tour_virtual.text) || ''
        }))), (ads_promotions || featured) && (/*#__PURE__*/React.createElement(BlockText, polycardStore._extends({}, ads_promotions || featured, {
          key: ads_promotions && 'ads_promotions' || featured && 'featured',
          className: classnames__default["default"]({
            'poly-component__ads-promotions': !!ads_promotions,
            'poly-component__featured': !!featured
          }),
          text: (ads_promotions == null ? void 0 : ads_promotions.text) || (featured == null ? void 0 : featured.text) || ''
        })))]
      }), bookmarkAction && bookmark && jsxRuntime.jsx(Bookmark, {})]
    }), unique_id), isList && jsxRuntime.jsx(Suggestions, {})]
  });
};
exports.Card = Card;
exports.cardNamespace = cardNamespace;
exports.useCardContext = useCardContext;
